import { Card, CopyArea } from "../shared"
import RadioGroup from "../shared/inputs/CalculatorRadioGroup"
import React, { FC, useEffect, useState } from "react"
import { VertigoProps } from "./types"
import { useTranslation } from "../utils"
import getQuery from "../utils/query"
import locales from "./locales"
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

const options = ["0", "1", "2", "3", "4"]

const Vertigo: FC<VertigoProps> = ({ ...queryProps }) => {
  const {
    width,
    title,
    description,
    locale = "no",
    variant = "outlined",
    showFooter = true,
    showSummary = true,
  } = getQuery(queryProps)
  const [t] = useTranslation({ locale, locales })
  const [result, setResult] = useState<number>(0)
  const [values, setValues] = useState<{ [key: string]: string }>({
    "1": "0",
    "2": "0",
    "3": "0",
    "4": "0",
    "5": "0",
    "6": "0",
    "7": "0",
    "8": "0",
    "9": "0",
    "10": "0",
    "11": "0",
    "12": "0",
    "13": "0",
    "14": "0",
    "15": "0",
  })

  useEffect(() => {
    setResult(
      Object.values(values)
        .map((a) => Number(a))
        .reduce((a, b) => a + b, 0)
    )
  }, [values])

  const handleChange = (
    event: React.ChangeEvent<{ value: string; name: string }>
  ) => {
    setValues({ ...values, [event.target.name]: event.target.value })
  }

  return (
    <Card
      title={title ?? t("title")}
      description={description ?? t("description")}
      locale={locale}
      width={width}
      showFooter={showFooter}
    >
      <Grid container spacing={2} direction="column">
        {Array.from(Array(15)).map((_, index) => {
          const input = t(`inputs.${index + 1}`)
          return (
            <StyledGrid
              item
              key={input}
            >
              <RadioGroup
                label={`${index + 1}. ${input}`}
                name={(index + 1).toString()}
                options={options.map((number) => {
                  return {
                    label: t(`inputs.options.${number}`),
                    value: number.toString(),
                  }
                })}
                value={values[(index + 1).toString()]}
                onChange={handleChange}
                style={{ gridGap: "0.825rem" }}
                direction={"column"}
                points={false}
              />
            </StyledGrid>
          )
        })}
      </Grid>
      <StyledGrid2
        container
        justifyContent="space-between"
      >
        <Grid item xs={12}>
          <Typography variant="body1">
            <strong>{t("result")}: </strong>
            {result}
          </Typography>
        </Grid>
      </StyledGrid2>
      {showSummary ? (
        <CopyArea
          label={t("summary")}
          locale={locale}
          value={{
            header: [t("summary"), t("title")].join(": "),
            lines: [[t("result"), result].join(": ")],
          }}
          TextAreaProps={{ variant }}
        />
      ) : null}
    </Card>
  )
}

export default Vertigo

const StyledGrid = styled(Grid)(() => ({
  paddingTop: "15px",
  paddingBottom: "10px",
}))

const StyledGrid2 = styled(Grid)(({ theme }) => ({
  paddingTop: theme.spacing(3),
}))